/**
 * Clean a reference title by stripping the site suffix after "|".
 * e.g. "How segments work | Customer.io Docs" → "How segments work"
 */
export function cleanReferenceTitle(title: string): string {
  const parts = title.split('|');
  if (parts.length > 1) {
    return parts.slice(0, -1).join('|').trim();
  }
  return title.trim();
}

export interface ToolCallReference {
  title?: string;
  url?: string;
}

/**
 * Deduplicate references by cleaned title, keeping the first occurrence.
 * Strips site suffixes and filters out empty titles.
 */
export function dedupeReferences(
  references: ToolCallReference[] | null | undefined,
): Array<{ title: string; url?: string }> {
  if (references == null) return [];
  const seen = new Set<string>();
  const result: Array<{ title: string; url?: string }> = [];

  for (const reference of references) {
    if (reference.title == null) continue;
    const cleaned = cleanReferenceTitle(reference.title);
    if (cleaned.length === 0 || seen.has(cleaned)) continue;
    seen.add(cleaned);
    result.push({ title: cleaned, url: reference.url });
  }

  return result;
}
